module.exports = __webpack_public_path__ + "img/Suldeste.4e8e1c16.svg";